module.exports = __webpack_public_path__ + "img/muser.9a49b4db.png";